import {CreateGuesser} from "@api-platform/admin";
import {MedicalAdviceForm} from "../components/MedicalAdviceForm";

export const MedicalAdviceCreate = props => (
    <CreateGuesser {...props}>
        <MedicalAdviceForm />
    </CreateGuesser>
);
